// extracted by mini-css-extract-plugin
export default {"settings-content-title":"ContentTitle_settings-content-title__8Zn3f"};